import { IsPotentialNumberText } from "./types";

// Allow only characters that could form a number while typing (blocks letters, etc.)
export const isPotentialNumberText: IsPotentialNumberText = (text) =>
  /^-?\d*\.?\d*$/.test(text);
